import apiRecommended from 'lib/apiRecommended';

// Import Types from shared file
import {
  LOAD_VIDEOS_BY_IDS_SUCCESS,
} from 'redux/modules/video/types';

// Types
export const RECOMMENDED_SUCCESS = 'recommended/RECOMMENDED_SUCCESS';
export const RECOMMENDED_PENDING = 'recommended/RECOMMENDED_PENDING';
export const RECOMMENDED_FAILED = 'recommended/RECOMMENDED_FAILED';

export const loadRecommendations = (url, options = {}, recType) => apiRecommended({
  url,
  options,
  types: [RECOMMENDED_PENDING, RECOMMENDED_SUCCESS, RECOMMENDED_FAILED],
  recType,
});

// Reducer
const INITIAL_STATE = {
  loading: false,
  recommendations: {},
};

export default function (state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case RECOMMENDED_SUCCESS:
      return {
        loading: false,
        recommendations: {
          ...state.recommendations,
          [payload.recType]: payload.data,
        },
      };

    case LOAD_VIDEOS_BY_IDS_SUCCESS:
      return {
        recommendations: {
          ...state.recommendations,
          [payload.cacheKey]: {
            headline: '',
            recommendations: true,
            videos: Object.values(payload.data).filter((v) => v),
          },
        },
      };

    case RECOMMENDED_PENDING:
      return {
        ...state,
        loading: true,
      };

    case RECOMMENDED_FAILED:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
